import {
  ScrollScene,
  globalScrollService,
} from '$app/scrolling/global-scroll-service.js';
import { stickySupport } from '$app/shared/utils.js';

export default class PhotoOverlayHeader {
  constructor(options) {
    this.el = options.el;
  }

  render() {
    const element = this.el.querySelector('.hed-container');

    this.scene = new OverlayScene(element);
    globalScrollService.addScene(this.scene);
  }
}

class OverlayScene extends ScrollScene {
  constructor(element) {
    super(element);

    this.overlay = this.sceneElement.querySelector('.hed-overlay');
    this.supportsStickyPosition = stickySupport();
    this.stickyElement = this.sceneElement.querySelector('.fullscreen-photo');
  }

  progress(p) {
    this.overlay.style.opacity = 1 - p;

    if (!this.supportsStickyPosition) {
      if (p === 0) {
        this.stickyElement.style.top = '64';
        this.stickyElement.style.bottom = 'auto';
      } else if (p === 1) {
        this.stickyElement.style.top = 'auto';
        this.stickyElement.style.bottom = '0';
      } else if (p > 0) {
        this.stickyElement.style.top = '64';
        this.stickyElement.style.bottom = 'auto';
      }
    }
  }

  start() {
    if (!this.supportsStickyPosition) {
      this.stickyElement.style.position = 'fixed';
    }
  }

  end() {
    if (!this.supportsStickyPosition) {
      this.stickyElement.style.position = 'absolute';
    }
  }
}
